import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowLeft, MessageSquare, Maximize2, Minimize2, ChevronDown, ChevronUp, KeyRound } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AMAZON_Q_URL = 'https://anyedl8j.chat.qbusiness.ap-southeast-2.on.aws/';

const AmazonQChat = ({ onLogout }) => {
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [credsOpen, setCredsOpen] = useState(true);

  useEffect(() => {
    if (credsOpen) {
      const timer = setTimeout(() => setCredsOpen(false), 30000);
      return () => clearTimeout(timer);
    }
  }, [credsOpen]);

  if (isFullscreen) {
    return (
      <div className="fixed inset-0 z-50 bg-white flex flex-col">
        <div className="flex items-center justify-between px-4 py-2 border-b" style={{ backgroundColor: '#A8A67A' }}>
          <div className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-white" />
            <span className="font-semibold text-white text-lg">Amazon Q - Knowledge Base</span>
          </div>
          <Button
            onClick={() => setIsFullscreen(false)}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-white/20"
            data-testid="amazonq-minimize-button"
          >
            <Minimize2 className="w-4 h-4 mr-1" />
            Exit Fullscreen
          </Button>
        </div>
        <iframe
          src={AMAZON_Q_URL}
          title="Amazon Q Business Chat"
          className="flex-1 w-full border-0"
          data-testid="amazonq-iframe"
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <div className="border-b bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              onClick={() => navigate('/')}
              variant="ghost"
              size="sm"
              className="flex items-center gap-2 text-slate-600 hover:text-slate-900"
              data-testid="amazonq-back-button"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </Button>
            <div className="h-6 w-px bg-slate-300" />
            <div className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5" style={{ color: '#A8A67A' }} />
              <h1 className="text-xl font-bold text-slate-800">Amazon Q - Knowledge Base</h1>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              onClick={() => setIsFullscreen(true)}
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
              data-testid="amazonq-fullscreen-button"
            >
              <Maximize2 className="w-4 h-4" />
              Fullscreen
            </Button>
            <Button
              onClick={onLogout}
              variant="outline"
              size="sm"
              data-testid="amazonq-logout-button"
            >
              Logout
            </Button>
          </div>
        </div>
      </div>

      {/* Credentials Banner + Chat Container */}
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="mb-4 bg-amber-50 border border-amber-200 rounded-lg overflow-hidden transition-all duration-300" data-testid="amazonq-credentials-banner">
          <button
            onClick={() => setCredsOpen(!credsOpen)}
            className="w-full px-5 py-2.5 flex items-center justify-between cursor-pointer hover:bg-amber-100/50 transition-colors"
            data-testid="amazonq-credentials-toggle"
          >
            <div className="flex items-center gap-2">
              <KeyRound className="w-4 h-4 text-amber-600" />
              <span className="text-amber-700 font-medium text-sm">Amazon Q Sign-in Credentials</span>
            </div>
            {credsOpen ? <ChevronUp className="w-4 h-4 text-amber-600" /> : <ChevronDown className="w-4 h-4 text-amber-600" />}
          </button>
          {credsOpen && (
            <div className="px-5 pb-3 flex items-center gap-6 text-sm border-t border-amber-200 pt-2.5">
              <span className="text-slate-700">Username: <code className="bg-white px-2 py-0.5 rounded border font-mono text-slate-900">test_poc3</code></span>
              <span className="text-slate-700">Password: <code className="bg-white px-2 py-0.5 rounded border font-mono text-slate-900">COI1Zr#5J5ljg</code></span>
            </div>
          )}
        </div>
        <div className="bg-white rounded-xl shadow-lg border overflow-hidden" style={{ height: 'calc(100vh - 190px)' }}>
          <iframe
            src={AMAZON_Q_URL}
            title="Amazon Q Business Chat"
            className="w-full h-full border-0"
            style={{ minWidth: '450px' }}
            data-testid="amazonq-iframe"
          />
        </div>
      </div>
    </div>
  );
};

export default AmazonQChat;
